module.exports = __webpack_public_path__ + "img/irel.221416c8.jpg";